<template lang="pug">
  #reviews
    v-layout(row justify-center)
      v-dialog(v-model="dialog" persistent max-width="850")
        v-card.py-5
            p.headline.text-xs-center ¿Estás seguro de que quieres verificar este folio?
            //v-card-text xxxxxx
            v-spacer.mt-4
            v-layout.px-5
              v-flex.px-5(d-flex xs6 justify-center)
                v-btn.dark-btn.bold(@click.native="dialog = false") CANCELAR
              v-flex.px-5(d-flex xs6 justify-center)
                v-btn.dark-btn.bold(@click.native="addReview") VERIFICAR FOLIO
    v-container(fluid)
      v-layout.py-3(row wrap
        v-if="reviews.length >= 1"
      )
        v-container(xs-12 fluid)
          h1.form-title.dark-text Revisiones de la postal:
        v-container(xs-8 fluid)
          v-layout(column
            v-for="(review, index) in reviews.slice(-3)"
          )
            v-form.pt-3.pb-2
              v-layout(row wrap align-start)
                v-flex(xs10)
                  v-layout(row wrap align-center)
                    v-flex.px-3(xs6)
                      v-text-field(
                        disabled
                        label="Persona que revisó"
                        :value="review.who"
                      )
                    v-flex.px-3(xs6)
                      v-text-field(
                        disabled
                        label="Fecha de revisión"
                        :value="review.when"
                      )
                    v-flex.px-3.pt-2(xs12)
                      multi-line(
                        disabled
                        multi-line
                        label="Comentarios de la revisión"
                        :value="review.comments"
                        placeholder="No hay comentarios"
                      )
                v-flex.pt-3(xs2)
                  v-layout(row wrap justify-center)
                    v-flex.px-3(d-flex xs12 justify-center)
                      img(v-if="review.changes === 'La postal es correcta'", src="/static/check.svg")
                      img(v-else, src="/static/cross.svg")
                //v-flex.px-3(xs2)
                  a.dark-text(href="") Ver esta versión
            v-divider(v-if="index < reviews.length - 1")
      v-layout.py-3(row wrap v-else)
        v-container(xs-12 fluid)
          h1.form-title.dark-text Revisiones de la postal:
          br
          p Aún no se han realizado revisiones a esta postal.
      v-container(fluid)
        h1.form-title.dark-text Envía una revisión:
        v-form
          v-layout(row wrap)
            v-radio-group(
              v-model="reviewReason"
            )
              v-flex(d-flex)
                v-radio(
                  label="La postal es correcta"
                  value="right"
                )
                v-radio(
                  label="La postal tiene errores"
                  value="wrong"
                )
          v-layout(row wrap)
            v-text-field(
              label="Comentarios"
              v-model="reviewComments"
            )
        v-layout(row wrap justify-end)
          v-flex(d-flex xs6)
            v-btn.dark-btn.bold(@click="openDialog") Guardar Revisión

</template>

<script>
export default {
  name: "Reviews",
  props: {},
  data() {
    return {
      dialog: false
    };
  },
  computed: {
    record() {
      return this.$store.getters.record;
    },
    reviews() {
      return this.$store.getters.record.reviews;
    },
    reviewReason: {
      get() {
        return this.$store.state.record["review_reason"];
      },
      set(value) {
        this.$store.commit("updateReviewReason", value);
      }
    },
    reviewComments: {
      get() {
        return this.$store.state.record["review_comments"];
      },
      set(value) {
        this.$store.commit("updateReviewComments", value);
      }
    }
  },
  methods: {
    addReview() {
      // console.log('record', this.record)
      this.$store.commit("setIsLoadingState", true);
      this.$store
        .dispatch("addReview")
        .then(response => {
          // console.log(response)
          this.dialog = false;
          this.$store.commit("SET_ADDREVIEW_SUCCESS", {
            pending: false,
            statusCode: response.status,
            data: response.data
          });
          this.$notify({
            group: "foo",
            type: "success",
            title: "ÉXITO",
            text: response.data.message
          });
          this.$store
            .dispatch("sendPushNotification", {
              title: `VERIFICADA AGRESIÓN #${response.data.folio} `,
              body: `${
                this.record.details
              }`,
              click_action: ""
            })
            .then(response => {
              // console.log(response)
            })
            .catch(error => {
              // console.log(error)
              // console.log(error.response)
            });
          this.$store.commit("resetReview");
          this.$store.commit("setIsLoadingState", false);
        })
        .catch(error => {
          // console.log(error)
          // console.log(error.response);
          this.dialog = false;
          this.$store.commit("SET_ADDREVIEW_FAILURE", {
            pending: false,
            statusCode: error.status
          });
          this.$notify({
            group: "foo",
            type: "error",
            title: "ERROR",
            text: error.response.data.message
          });
          this.$store.commit("setIsLoadingState", false);
        });
    },
    openDialog() {
      if (
        this.record["_id"] === "" ||
        typeof this.record["_id"] === "undefined"
      ) {
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: "No has seleccionado un folio"
        });
      } else if (
        this.record.review_reason === "" ||
        typeof this.record.review_reason ===
          "undefined" /*
        || (this.record.review_comments === '' || typeof this.record.review_comments === 'undefined')*/
      ) {
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: "No has seleccionado el tipo de revisión"
        });
      } else {
        this.dialog = true;
      }
    }
  },
  updated() {},
  mounted() {
    // console.log(this.record)
    // this.$store.state.record["review_reason"] = "right"
  }
};
</script>

<style scoped lang="scss">
</style>
